import React from 'react';
import { PRODUCT_COLORS } from '../lib/constants';

export default function InlineSelect({ value, options, onSave, isProducto = false }) {
  const [open,  setOpen]  = React.useState(false);
  const [val,   setVal]   = React.useState(value || '');
  const [dropPos,setDropPos] = React.useState({ top: 0, left: 0 });
  const btnRef = React.useRef(null);
  const dropRef = React.useRef(null);

  React.useEffect(() => {
    if (!open) return;
    const close = (e) => {
      if (btnRef.current && btnRef.current.contains(e.target)) return;
      if (dropRef.current && dropRef.current.contains(e.target)) return;
      setOpen(false);
    };
    document.addEventListener('mousedown', close, true);
    return () => document.removeEventListener('mousedown', close, true);
  }, [open]);

  const handleOpen = (e) => {
    e.stopPropagation();
    if (btnRef.current) {
      const r = btnRef.current.getBoundingClientRect();
      setDropPos({ top: r.bottom + 4, left: r.left });
    }
    setOpen(p => !p);
  };

  const handleSelect = async (opt, e) => {
    e.stopPropagation();
    setVal(opt);
    setOpen(false);
    await onSave(opt);
  };

  const color = isProducto ? (PRODUCT_COLORS[val] || 'rgba(255,255,255,0.35)') : null;

  return (
    <div className="inline-select-wrap" onClick={e => e.stopPropagation()}>
      <button ref={btnRef}
        className={`inline-select-tag${isProducto ? ' producto' : ' proceso'}`}
        style={isProducto && color ? { borderColor: color + '55', color } : {}}
        onClick={handleOpen}
      >
        {val || '—'}<span style={{opacity:0.4,marginLeft:2,fontSize:8}}>{'▾'}</span>
      </button>
      {open && (
        <div ref={dropRef} className="inline-select-dropdown"
          style={{ top: dropPos.top, left: dropPos.left }}>
          {options.map(opt => (
            <button key={opt} className="inline-select-option"
              style={isProducto ? { color: PRODUCT_COLORS[opt] || 'inherit' } : {}}
              onClick={e => handleSelect(opt, e)}
            >{opt}</button>
          ))}
        </div>
      )}
    </div>
  );
}
